import a from "./index885.js";
import r from "./index815.js";
var e = "[object Map]";
function i(t) {
  return r(t) && a(t) == e;
}
export {
  i as default
};
